













import { Component, Vue, Prop } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';

@Component({

})
export default class OrderFailureModalContent extends Vue {

    public goBack() {
        this.$store.commit(Mutations.SET_ORDER_PAY_FAILURE_MODAL_VISIBILITY, false);
    }

}
